import moment, { Moment } from 'moment';
import React from 'react';
import GridFilter from '../../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../Base/Enums/GridFilterItemType.enum';
import { useAppContext } from '../../../../../Services/AppContext';
import { GRID_FILTER_KEYS } from '../../../../Base/Components/GridFilter/gridFilterKeys';

export interface WorkplaceCasesFilterValues {
	createdAt?: Moment | string;
	patientId?: string;
	workplaceIds: string[];
	workplaceId: string;
}

interface Props {
	onFilter: (values: WorkplaceCasesFilterValues) => void;
}

const WorkplaceCasesFilter: React.FC<Props> = ({ onFilter }) => {
	const { workplaceId } = useAppContext();
	const onFilterData = (values: any) => {
		const filter: WorkplaceCasesFilterValues = {
			createdAt: values?.createdAt
				? moment(values.createdAt).format('YYYY-MM-DD')
				: undefined,
			patientId: values?.patient?.value || undefined,
			workplaceIds: [workplaceId],
			workplaceId,
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.WORKPLACE_CASES_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ORIGINAL_ID}
				width={320}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.CREATED_AT}
				width={190}
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default WorkplaceCasesFilter;
